
import { TableSessionType } from '../../Common/Enum/TableSessionType';
import AppData from './../../../Model/AppData';
import DeliveryDetail from '../../../Model/DeliveryDetail';
import { TableType } from '../../../components/merchant/Enum/TableType';
import DeliveryDetailRepository from '../../../components/repository/DeliveryDetailRepository';

let _deliveryDistanceData = {}
let _tableSessionType = TableSessionType.DINE_IN
let _addressComponents = null
let _streetNumber = null
let _coordinate = null

// This final object to be sent to server
let _deliveryDetail = null

const _localStorageKey = "OrderHandlerData"
const saveToLocalStorage = (key, value) => {
    let data = {}
    let oldData = localStorage.getItem(_localStorageKey) || {}
    if (oldData) {
        if (oldData == "[object Object]") {
            oldData = {}
        }
        else {
            oldData = JSON.parse(oldData)
        }
    }
    data = {
        ...oldData,
        [key]: value,
    }

    localStorage.setItem(_localStorageKey, JSON.stringify(data))
}

let _loadOnce = false
const callbackKey = "OrderHandler"
export default class OrderHandler {
    static initTableSessionTypeForOnlineTable = (table, tableSession, currencyName) => {
        // Is tableSessionType from TableSession if possible
        let tableSessionType = tableSession && parseInt(tableSession.table_session_type_id) || OrderHandler.getTableSessionType()
        let isPickupTable = (table.table_type_bitwise & TableType.BIT_PICKUP) > 0
        let isDeliveryTable = (table.table_type_bitwise & TableType.BIT_DELIVERY) > 0
        let isDineInTable = (table.table_type_bitwise & TableType.BIT_DINEIN) > 0

        const pairing = [
            {
                tableTypeBit: TableType.BIT_DINEIN,
                sessionType: TableSessionType.DINE_IN,
            },
            {
                tableTypeBit: TableType.BIT_PICKUP,
                sessionType: TableSessionType.PICKUP,
            },
            {
                tableTypeBit: TableType.BIT_DELIVERY,
                sessionType: TableSessionType.DELIVERY,
            },
        ]

        let tableSessionTypeNotMatchTableType
        for (let i = 0; i < pairing.length; i++) {
            let pair = pairing[i]
            let isTableTypeAllowed = (table.table_type_bitwise & pair.tableTypeBit) > 0

            // Example: current selected table session type is DineIn, but table type only allow Pickup and Delivery,
            // so this tableSessionType is invalid
            tableSessionTypeNotMatchTableType = !isTableTypeAllowed && tableSessionType == pair.sessionType
            if (tableSessionTypeNotMatchTableType) {
                break;
            }
        }

        if (tableSessionTypeNotMatchTableType) {
            // Set it to the type that matches the table, according to priority as in "pairing"
            for (let i = 0; i < pairing.length; i++) {
                let pair = pairing[i]
                let isTableTypeAllowed = (table.table_type_bitwise & pair.tableTypeBit) > 0
                if (isTableTypeAllowed) {
                    tableSessionType = pair.sessionType
                }
            }
        }
        if (tableSessionType == TableSessionType.DELIVERY && !OrderHandler.getDeliveryDetail()) {
            tableSessionType = TableSessionType.PICKUP
        }
        if (tableSession && tableSession.delivery_detail_id && !OrderHandler.getDeliveryDetail()) {
            DeliveryDetailRepository.getInstance().loadOne(tableSession.delivery_detail_id, (deliveryDetail) => {
                let distanceData = {
                    distance_text: (deliveryDetail.distance || 0) + ' km',
                    duration_text : (deliveryDetail.duration || 0) + ' minute',
                    price_text: "≈ " + (currencyName ? currencyName : "RM" ) + " " + (parseFloat(deliveryDetail.deliveryCharge || 0)).toFixed(2),
                }

                // id need to be null, else when confirm order will get duplicate id error
                OrderHandler.setDeliveryDetail({...deliveryDetail, id: null})
                OrderHandler.setDeliveryDistanceData(distanceData)
                OrderHandler.setDeliveryAddressComponents(deliveryDetail.addressComponents)
                OrderHandler.setDeliveryStreetNumber(deliveryDetail.streetNumber)

                // Reinit again in case user change order type while we are waiting for delivery detail to be loaded
                OrderHandler.initTableSessionTypeForOnlineTable(table, tableSession)
            }, callbackKey, this)
        }
        
        OrderHandler.setTableSessionType(tableSessionType)
    }
    /**
     * Call this on page load to restore data
     */
    static loadFromLocalStorage = () => {
        if (!_loadOnce) {
            _loadOnce = true
            let data = localStorage.getItem(_localStorageKey)
            if (data && data != "[object Object]") {
                data = JSON.parse(data)
                _deliveryDistanceData = data['deliveryDistanceData']
                _tableSessionType = data['tableSessionType']
                _addressComponents = data['addressComponents']
                _streetNumber = data['streetNumber']
                _coordinate = data['deliveryCoordinate']

                if (data['deliveryDetail']) {
                    _deliveryDetail = Object.assign(new DeliveryDetail(), data['deliveryDetail'])
                }
            }
        }
    }

    /**
     * Use this to clean up data after user confirm order
     * so that next new order shall start from a 'clean' state
     */
    static removeFromLocalStorage = () => {
        localStorage.removeItem(_localStorageKey)
    }

    static setDeliveryDistanceData = (data) => {
        _deliveryDistanceData = data
        saveToLocalStorage('deliveryDistanceData', data)
    }
    static getDeliveryDistanceData = () => {
        return _deliveryDistanceData
    }
    static clearDeliveryData = () => {
        _deliveryDistanceData = {}
    }
    static setTableSessionType = (tableSessionType) => {
        _tableSessionType = tableSessionType
        saveToLocalStorage('tableSessionType', tableSessionType)
        AppData.data.forceUpdate()
    }
    static getTableSessionType = () => {
        return _tableSessionType
    }
    static setDeliveryAddressComponents = (addressComponents) => {
        _addressComponents = addressComponents
        saveToLocalStorage('addressComponents', addressComponents)
    }
    static getDeliveryAddressComponents = () => {
        return _addressComponents
    }
    static setDeliveryStreetNumber = (streetNumber) => {
        _streetNumber = streetNumber
        saveToLocalStorage('streetNumber', streetNumber)
    }
    static getDeliveryStreetNumber = () => {
        return _streetNumber
    }
    static setDeliveryCoordinate = (coor) => {
        _coordinate = coor
        saveToLocalStorage('deliveryCoordinate', coor)
    }
    static getDeliveryCoordinate = () => {
        return _coordinate
    }
    static setDeliveryDetail = (deliveryDetail) => {
        saveToLocalStorage('deliveryDetail', deliveryDetail)
        _deliveryDetail = deliveryDetail
    }
    static getDeliveryDetail = () => {
        return _deliveryDetail
    }
}

// Load data when we include this module
OrderHandler.loadFromLocalStorage()